import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export interface InvestmentsSummaryType {
  combined: {
    totalCount: number;
    totalTypesCount: number;
  };
  [currency: string]: { totalValue: number } | { totalCount: number; totalTypesCount: number };
}

export default function useGetInvestmentsSummary(enabled = true) {
  return useQuery({
    queryKey: ["investments/summary"],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/summary")
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: InvestmentsSummaryType) => data,
    retry: false,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
}
